import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useCallback, useState } from "react";
import { parseError } from "../../../../utils/shared";
import httpClient from "../../../../api/httpClient";
import { downloadDirectFile } from "../../../../utils/files";

const DownloadInvoice = ({ record, tenant_id }) => {
  const [downLoading, setDownloading] = useState(false);

  const handleDownloadInvoice = useCallback(async () => {
    try {
      setDownloading(true);

      const { data } = await httpClient.get("paddle/get-invoice", {
        params: {
          tenant_id,
          transaction_id: record?.id,
        },
      });

      const url = data?.data?.url;

      if (!url) throw new Error("Invoice URL not found");

      await downloadDirectFile(url);

      message.success("Invoice downloaded successfully");
    } catch (error) {
      parseError(error, true);
    } finally {
      setDownloading(false);
    }
  }, [record, tenant_id]);

  return (
    <>
      {record?.status === "completed" &&
      Number(record?.details?.totals?.grand_total) > 0 ? (
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          size="small"
          onClick={handleDownloadInvoice}
          loading={downLoading}
          disabled={downLoading}
        />
      ) : (
        "-"
      )}
    </>
  );
};
export default DownloadInvoice;
